import { Injectable, InputSignal } from '@angular/core';
import { ObjetMaquette } from '@app/features/editeur/models/objet-maquette.model';
import { Espace, TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { AbstractDescripteursForm } from './abstract-descripteurs-form';

@Injectable()
export abstract class AbstractDescripteursComponent {
    readonly espace: InputSignal<Espace>;
    readonly objetMaquette: InputSignal<ObjetMaquette | undefined>;
    readonly typeObjetMaquette: InputSignal<TypeObjetMaquette | undefined>;
    form: AbstractDescripteursForm;

    get isFormation(): boolean {
        return this.typeObjetMaquette() === TypeObjetMaquette.Formation;
    }

    get isGroupement(): boolean {
        return this.typeObjetMaquette() === TypeObjetMaquette.Groupement;
    }

    get isObjetFormation(): boolean {
        return this.typeObjetMaquette() === TypeObjetMaquette.ObjetFormation;
    }

    reset(): void {
        this.form.reset();
    }
}
